import { action, payload } from 'ts-action';
import Score from '../../@types/score.interface';

export interface IInsertScorePayload {
    name: 'INSERT_SCORE';
    data: {
        quiz_id: number;
        email_address: string;
    };
}

export interface IFetchScorePayload {
    name: 'SCORE';
    data: {
        quiz_id: number;
        email_address: string;
    };
}

export interface IFetchScoresPayload {
    name: 'SCORES';
    data: {
        email_address: string;
    };
}

export const SCORE = 'SCORE';
export const SCORES = 'SCORES';
export const CLEAR_SCORE = 'CLEAR_SCORE'; 
export const CLEAR_SCORES = 'CLEAR_SCORES';

export const fetchScore = action(SCORE, payload<{ score: number }>());
export const fetchScores = action(SCORES, payload<{ scores: Score[] }>());
export const clearScore = action(CLEAR_SCORE);
export const clearScores = action(CLEAR_SCORES);

export type ScoreActionType =
    | ReturnType<typeof fetchScore>
    | ReturnType<typeof fetchScores>
    | ReturnType<typeof clearScore>
    | ReturnType<typeof clearScores>;

const ScoreActionAPI = {
    clearScore,
    clearScores,
};

export default ScoreActionAPI;
